import { render, staticRenderFns } from "./WarehouseLocationViewer.vue?vue&type=template&id=0152a8fa&scoped=true"
import script from "./WarehouseLocationViewer.vue?vue&type=script&lang=js"
export * from "./WarehouseLocationViewer.vue?vue&type=script&lang=js"
import style0 from "./WarehouseLocationViewer.vue?vue&type=style&index=0&id=0152a8fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0152a8fa",
  null
  
)

export default component.exports